import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const lens      = document.getElementById('image-zoom-container');
    const lensSize  = 200;
    const zoomLevel = 3;
    let isHovered   = false
    let isLoaded    = false

    this.element.addEventListener('mouseenter', (e) => {
      this.isHovered = true
      lens.style.backgroundImage = `url('${e.currentTarget.src}')`;
    })

    // For live view
    this.element.onload = (e) => {
      this.isLoaded = true
      if (this.isHovered) lens.style.backgroundImage = `url('${e.currentTarget.src}')`;
    }

    this.element.addEventListener('mousemove', (e) => {
      if (e.currentTarget.dataset.hideZoom == "true") return
      if (!this.isLoaded) return

      lens.style.backgroundImage = `url('${e.currentTarget.src}')`;

      const rect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Determine lens position: right of cursor by default
      let lensLeft = e.clientX + 20;
      const lensRightEdge = lensLeft + lensSize;

      // If lens goes outside viewport, move it to the left
      if (lensRightEdge > window.innerWidth) {
        lensLeft = e.clientX - 20 - lensSize;
      }

      lens.style.left = `${lensLeft}px`;
      lens.style.top = `${e.clientY - lensSize / 2}px`;

      // Set background zoom
      lens.style.backgroundSize = `${e.currentTarget.width * zoomLevel}px ${e.currentTarget.height * zoomLevel}px`;
      lens.style.backgroundPosition = `-${x * zoomLevel - lensSize / 2}px -${y * zoomLevel - lensSize / 2}px`;

      lens.style.display = 'block';
    });

    this.element.addEventListener('mouseleave', () => {
      this.isHovered     = false
      lens.style.display = 'none';
    });
  }
}
